import Macy from 'macy'
const masonry = Macy({
    container: '#macy',
    columns: 2,
    margin: {
        x: 30,
        y: 30
    },
    breakAt: {
        760: {
            margin: {
                x: 5,
                y: 5,
            },
            columns: 1
        }
    }

});